// A bare 422 is not enough to identify a rejected token:
// Order::CartController#set_delivery_option_for_items answers 422 for a business error
// that the caller surfaces from the response body. The server marks a forgery rejection
// with this header (CsrfRejectionResponse).
const CSRF_REJECTED_HEADER = 'X-CSRF-Rejected';

// Cart actions fire on mount, and the pickup-location PUT is what persists the state
// whose mismatch triggers one, so an unbounded reload is reachable with no user input.
// A success clears the marker so a later rejection recovers straight away rather than
// waiting the window out.
const RELOAD_MARKER = 'csrf-token-reloaded-at';
const RELOAD_WINDOW_MS = 5 * 60 * 1000;

function isCsrfRejection(response) {
  return (
    response.statusCode === 422 &&
    response.headers?.get(CSRF_REJECTED_HEADER) != null
  );
}

function reloadOnceForCsrfRejection() {
  const now = Date.now();

  // Without storage the window cannot be enforced. Losing the recovery is the safe
  // failure; an unbounded reload loop is not.
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_MARKER));

    if (last && now - last < RELOAD_WINDOW_MS) {
      return;
    }
  } catch {
    return;
  }

  // Recorded on the way out rather than up front. The prints builder warns about
  // unsaved changes on beforeunload, and a reload the customer cancels must not spend
  // the window and leave them unable to retry.
  window.addEventListener(
    'pagehide',
    () => {
      try {
        window.sessionStorage.setItem(RELOAD_MARKER, String(now));
      } catch {
        // Storage blocked; the window cannot be recorded.
      }
    },
    { once: true },
  );

  window.location.reload();
}

function clearCsrfReloadMarker() {
  try {
    window.sessionStorage.removeItem(RELOAD_MARKER);
  } catch {
    // Nothing to clear if storage is blocked.
  }
}

export {
  isCsrfRejection,
  reloadOnceForCsrfRejection,
  clearCsrfReloadMarker,
  CSRF_REJECTED_HEADER,
};
